import { gql } from '@urql/core';
import React from 'react';
import { PlayerCardBioFragment } from '../../../generated/spin-graphql';
import { PlainTextLocationDisplay } from '../../common/PlainTextLocationDisplay';

type Props = {
    className?: string;
    player: PlayerCardBioFragment;
};

gql`
    fragment PlayerCardBio on espin_player_profile {
        spin_username
        first_name
        last_name
        address {
            ...PlainTextLocationDisplay
        }
    }
`;

export const PlayerCardBio: React.FC<Props> = ({ className, player }) => {
    return (
        <div className="player-bio-container">
            <h2 className="player-gamertag">{player.spin_username}</h2>
            <p className="player-name">
                {player.first_name} {player.last_name}
            </p>
            <p className="player-location">
                <PlainTextLocationDisplay address={player.address} />
            </p>
        </div>
    );
};
